import { useState } from 'react';
import { Box, Button, ButtonGroup, Grid, TextField, Typography } from '@mui/material';
import { useUser } from '../../store/User';
import { updateUrl } from '../../api';
import './index.css';

const hiddenFields = ['aois', 'id', 'role'];

const Profile = ({viewModal}) => {
    const { user, setShowLogin, setUser } = useUser();

    const [editProfile, setEditProfile] = useState(false);

    const updateProfile = (key, value) => {
        let updatedUser = { ...user };
        updatedUser[key] = value;
        setUser(updatedUser);
    }

    const saveProfile = async () => {
      try {
        const response = await fetch(updateUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('terra-token')}`
          },
          body: JSON.stringify(user),
        });

        const result = await response.json();

        if (response.ok) {
          setUser(result);
          setEditProfile(false);
        } else if(response.status === 401) {
          setUser(null);
          setShowLogin(true);
        }

        setUser(result);
        setEditProfile(false);
      } catch (error) {
        console.error("Error fetching User:", error);
      }
    }

    const closeProfile = () => {
        setEditProfile(false);
        viewModal(false);
    }
    
    return (
        <Box className='modal-container'>
            <Typography id="modal-modal-title" variant="h5" component="h2">
              Profile
            </Typography>
            <Grid container spacing={2}>
              {Object.entries(user).filter(([key, value]) => !hiddenFields.includes(key)).map(([key, pValue]) => (
                <Grid size={12} container spacing={1} key={`profile-row-${key}`} sx={{ alignItems: "center"}}>
                  <Grid className="modal-key" size={4}>
                    <>{key}</>
                  </Grid>
                  <Grid size={8}>
                    {editProfile ? 
                      <TextField 
                        label={key.toLocaleUpperCase()} 
                        sx={{ width: '100%' }} 
                        variant="outlined" 
                        size="small"
                        value={pValue ? pValue : ''}
                        onChange={(e) => updateProfile(key, e.target.value)}
                      />
                    :
                      <>{pValue !== null ? pValue : ''}</>
                    }
                  </Grid>
                </Grid>
              ))}
            </Grid>
            <ButtonGroup size="small" sx={{ mt: 2, float: 'right' }}>
              { editProfile ?
              <Button onClick={() => saveProfile()}>
                SAVE
              </Button>
              :
              <Button onClick={() => setEditProfile(!editProfile)}>
                EDIT
              </Button>
              }
              <Button onClick={() => closeProfile(false)}>
                CLOSE
              </Button>
            </ButtonGroup>
        </Box>
    );
}

export default Profile;